import { Typography } from '@mui/material';

import { FBoxContainer } from '../../../base';
import SupervisionSessionNarrative from '../SupervisionSessionNarrative';
import { useParentSupervisionEditable } from '../../../../hooks';
import { useParentNarrativeSuggestion } from './hooks';
import { SupervisionNoteStatus } from '../../../../constants';
import { boxContainerHeaderStyle, boxContainerStyle, contentStyle } from './constants';
import { narrativeTextareaStyle } from '../styles';
import { FORTA_BLUE } from '../../../../utils/colors';
import { getParentSupervisionNarrativeSourceKey } from '../types';

import type { IParentSessionNarrativeProps, NarrativeUpdateContext } from '../types';

function ParentSessionNarrative({
  parentSupervision,
  showError,
  onUpdate,
}: IParentSessionNarrativeProps) {
  // Keep the narrative controls mounted while the page saves the note.
  const isEditable = useParentSupervisionEditable();
  const isSupervisionCompleted = parentSupervision?.status === SupervisionNoteStatus.Completed;
  const sourceKey = getParentSupervisionNarrativeSourceKey(parentSupervision);
  const noteId = parentSupervision?.id;
  const { narrativeSuggestionLoading, getNarrativeSuggestion } =
    useParentNarrativeSuggestion(noteId, sourceKey);

  const handleNarrativeUpdate = (
    nextNarrative: string,
    lastAiNarrative?: string,
    context?: NarrativeUpdateContext,
  ) => {
    if (!parentSupervision) return;

    return onUpdate({
      ...parentSupervision,
      session_narrative: nextNarrative,
      ...(lastAiNarrative !== undefined && {
        last_ai_generated_session_narrative: lastAiNarrative,
      }),
    }, context);
  };

  return (
    <FBoxContainer
      sx={boxContainerStyle}
      headerStyle={boxContainerHeaderStyle}
      contentStyle={contentStyle}
    >
      <Typography fontSize={21} textAlign="left" mt={1} mb={3} color={FORTA_BLUE.primary}>
        Session narrative
      </Typography>
      <SupervisionSessionNarrative
        dataTestId="sessionNarrativeParentSuperVisionTextField"
        noteType="97156"
        isEditable={isEditable}
        noteId={noteId}
        narrative={parentSupervision?.session_narrative}
        sourceKey={sourceKey}
        textareaSx={narrativeTextareaStyle(isSupervisionCompleted)}
        showError={showError}
        narrativeSuggestionLoading={narrativeSuggestionLoading}
        onSuggest={getNarrativeSuggestion}
        onUpdate={handleNarrativeUpdate}
      />
    </FBoxContainer>
  );
}

export default ParentSessionNarrative;
